export const RESPONSIBLE_TYPES = {
  SYSTEM: "SYSTEM",
  USER: "USER",
  PUBLIC_API: "PUBLIC_API"
};

export const RESPONSIBLE_TYPES_LIST = Object.values(RESPONSIBLE_TYPES).map(
  (value) => ({ value, label: value })
);
